module.exports = __webpack_public_path__ + "img/r.d062e298.jpg";